<template>
    <div class="occupation header breadcrumbs-absolute" :class="{'occupationPC':$store.state.innerWidth>768}">
      <div class="related-bread ">
        <Breadcrumbs  class="magazine-bread"></Breadcrumbs>
      </div>
       
        <div class="mask" @click="closePopup" :class="{'show':showEducationLevel,'maskPC':$store.state.innerWidth>768}"></div>
        <div class="occupation-contain">
            <div class="occupation-opportunityPC RelatedOccupationsMB col-sm-10 col-md-8 padLeft-0 padRight-0">
               
                <div class="jobFunction active jobFunctionJia" v-if="isFilter&&!$route.params.magazineId">
                    <Occupations v-bind:childLogGaEvent="childLogGaEvent" v-bind:keyword="keywordData"  v-bind:educationLevel="educationIdsData" class="occupations"></Occupations>
                </div>
                <div class="jobFunction active jobFunctionJia" v-if="$route.params.magazineId">
                    <Occupations v-bind:childLogGaEvent="childLogGaEvent" v-bind:magazineId="$route.params.magazineId" class="occupations"></Occupations>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import JobFunctionList from '@/components/JobFunctionList'
import Occupations from '@/components/Occupations'
export default {
    components: {
        Breadcrumbs,
        JobFunctionList,
        Occupations
    },
    props:[
        "logGaEvent"
    ],
    data() {
        return {
            totalRows: 0,
            jobFunctions: [],
            keyword: "",
            keywordData:"",
            showEducationLevel: false,
            educationLevelDisplay: '',
            selectedAllEducationLevel: false,
            isFilter: false,
            educationList: [],
            educationIds:"",
            educationIdsData:"",
        }
    },   
    computed:{
       
        _language(){
            return this.$store.state.language
        }
    },
    created() {
        this.getArticleDetail(this.$route.params.magazineId)
    },
    methods: {
        setBreadcrumbs:function(){
            if (this.$route.path.indexOf("RelatedOccupations") > 0) {
                var breadcrumbs = this.$route.meta.breadcrumbs.find(
                    b => b.to.indexOf("onlineMagazineDetail") > 0
                );
            
                if (breadcrumbs) {
                    breadcrumbs.text = this.$store.getters.getObject(
                        this.articleDetail.langMap
                    ).title;
                    breadcrumbs.to = "/onlineMagazineDetail/" + this.$route.params.magazineId;
                }
            }
        },
        getArticleDetail: function(id) {
            if(!id) return;
            var that = this;
            this.api.getArticleDetail(
                {
                articleId: id
                },
                function(data) {
                    that.articleDetail = data.result;
                    that.setBreadcrumbs();
                }
            );
        },
        childLogGaEvent:function(eventCategory, eventAction, eventLabel, eventValue) {
            this.logGaEvent(eventCategory, eventAction, eventLabel, eventValue)
        },
        openEducationLevel: function() {
            this.logGaEvent('userClick','filterBrowseOccupations','Education Level')
            this.showEducationLevel = !this.showEducationLevel;
            if (this.comment.getType()) {
                this.isMobile = true;
            }
        },
        selectAllEducationLevelFn: function() {
            let that = this
            this.logGaEvent('userSelect','educationLevel','All Education Level')
            that.selectedAllEducationLevel = !that.selectedAllEducationLevel
            that.educationList.map(function(v, i) {
                v.selected = that.selectedAllEducationLevel;
                return v
            });
        },
        defaultSearchFn: function() {
            this.isFilter = false;
            var that = this
            let data = {}

            that.api.getJobFunctionList(data, function(data) {
                that.totalRows = data.totalRows;
                that.jobFunctions = data.result;
            })

        },
        searchFn: function() {
            this.logGaEvent('userClick','searchButton','search')
            this.isFilter = (this.keyword||this.educationIds)
            if(this.isFilter){
                this.keywordData=this.keyword
                this.educationIdsData=this.educationIds
            }
        },
        getEducationListFn: function() {
            var that = this
            that.api.getEducationList({}, function(data) {
                that.educationList = data.result.map(function(v, i) { v.selected = false; return v });
            })
        },
        selectEducationLevelFn: function(obj) {
            this.logGaEvent('userSelect','educationLevel',this.$store.getters.getContent(obj.name))
            obj.selected = !obj.selected;
        },
        clickKeyword:function(){
            this.logGaEvent('userClick','filterBrowseOccupations','Keyword')
        },
        closePopup:function(){
            this.showEducationLevel = false;
        },
        clearEvent:function(){
            this.keyword = ""
            this.searchFn();
        },
    },
    mounted() {
        this.$store.state.selectMenu = 2;
        var that = this
     
        document.addEventListener('keydown', function (e) {
            if (e.keyCode === 13&&that.searchFn&&window.location.href.indexOf('RelatedOccupations')>0) {
              that.searchFn()
            }
        });
        this.defaultSearchFn();
      
        if(this.$store.state.occupationsFilter.keyword||this.$store.state.occupationsFilter.educationLevel){
            this.keyword=this.$store.state.occupationsFilter.keyword;
            this.educationIds=this.$store.state.occupationsFilter.educationLevel;
            this.$store.state.occupationsFilter={};
            this.searchFn()
        }
        // this.
        this.getEducationListFn()
        // searchFn
    },watch: {
        _language:{
            handler: function(val, oldVal) {
                this.setBreadcrumbs();
            
            },
            deep: true
        }
    }



}
</script>